module.exports = __webpack_public_path__ + "static/img/Bachelor_010247.7f4f3d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010247.jpg
// module id = 128
// module chunks = 0